import { useEffect, useMemo, useRef, useState } from "react";
import ReactPlayer from "react-player";
import React from "react";
import Stories from "react-insta-stories";
import {
  IOnboardDingPlaylistResponseField,
  IVideosField,
  IVideoSource,
  VideoQuality,
} from "~/lib/types/onboarding.videos.type";
import { useIsMobileUser } from "~/lib/utils/store/useIsMobileUser";
import { getStreamingDuration } from "~/lib/utils/streaming";
import { Promise } from "bluebird";

const ViewVideosSetel = ({
  videosPlaylist,
  setIndexPlaylist,
  indexPlaylist,
  playlistLength,
  setIndexVideos,
  indexCurrentVideo,
}: {
  videosPlaylist: IOnboardDingPlaylistResponseField;
  indexPlaylist: number;
  playlistLength: number;
  setIndexPlaylist: (index: number) => void;
  setIndexVideos: (index: number) => void;
  indexCurrentVideo?: number;
}) => {
  const { isMobileUser } = useIsMobileUser();
  const [stories, setStories] = useState<any>();
  const [isStoriesPaused, setStoriesPaused] = useState<boolean>(false);
  const indexPlaylistCurrent = () => {
    const indexNextVideo =
      indexPlaylist + 2 > playlistLength
        ? playlistLength - 1
        : indexPlaylist + 1;
    return indexNextVideo;
  };

  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isWebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
    navigator.userAgent
  );

  const selectVideoBaseOnNetworkEfficient = (videosSources: IVideoSource[]) => {
    const browserNavigator: any = (navigator as any).connection;

    // if browser support connection API
    let selectedUrl = videosSources[0].url;
    // slow-2g', '2g', '3g', or '4g'
    if (browserNavigator && !!browserNavigator.effectiveType) {
      let priority;
      if (browserNavigator.effectiveType === "4g") {
        priority = [VideoQuality.ORIGINAL, VideoQuality.FHD, VideoQuality.HD];
      } else if (browserNavigator.effectiveType === "3g") {
        priority = [VideoQuality.FHD, VideoQuality.HD, VideoQuality.ORIGINAL];
      } else {
        priority = [VideoQuality.HD, VideoQuality.FHD, VideoQuality.ORIGINAL];
      }

      priority.every((priority) => {
        const video = videosSources.find((item) => {
          return item.quality === priority;
        });

        if (video) {
          selectedUrl = video.url;
          return false;
        }
        return true;
      });
    }

    return selectedUrl;
  };

  useEffect(() => {
    if ((isMobileUser && isSafari) || (isMobileUser && isWebview)) {
      setTimeout(() => {
        setStoriesPaused(true);
      }, 1000);
    }
  }, [indexCurrentVideo]);

  useEffect(() => {
    const storiesPromises = videosPlaylist.videos.map(async (video, index) => {
      const url = selectVideoBaseOnNetworkEfficient(video?.sources);
      try {
        const duration = await getStreamingDuration(url);

        if (typeof duration !== "number") {
          return null;
        }

        const config = {
          file: {
            attributes: {
              poster: video?.thumbnailUrl,
              disablePictureInPicture: true,
              playsInline: true,
            },
          },
        };

        return {
          content: ({
            action,
            isPaused,
          }: {
            action: any;
            isPaused: boolean;
          }) => (
            <div className="react-player">
              <ReactPlayer
                playing={!isPaused}
                config={config}
                loop
                width="100%"
                url={url}
                controls={isMobileUser && (isWebview || isSafari)}
                playsinline
                style={{
                  minHeight: "100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
              />
              <div
                className={`absolute w-[90%] truncate top-[36px] left-[16px] text-[15px] font-medium leading-[21px] text-white capitalize`}
              >
                {video?.name}
              </div>
            </div>
          ),
          duration,
        };
      } catch (err) {
        return null;
      }
    });

    const generateStories = async () => {
      const res = await Promise.map(
        storiesPromises,
        (item) => {
          return item;
        },
        { concurrency: 4 }
      );
      const filteredStories = res.filter((item) => item !== null);

      if (!!filteredStories.length) {
        setStories(filteredStories);
      }
    };

    generateStories();
  }, []);

  return (
    <div
      className={`fixed items-center left-0 z-50 w-full h-full flex justify-center`}
    >
      <div
        className={"stories flex w-full h-full sm:w-auto sm:h-auto"}
        onClick={() => setStoriesPaused((prevState) => !prevState)}
      >
        {stories && (
          <Stories
            isPaused={isStoriesPaused}
            stories={stories}
            width={isMobileUser ? "100%" : "50vh"}
            height={isMobileUser ? "100%" : "90vh"}
            storyContainerStyles={{ margin: "auto" }}
            currentIndex={indexCurrentVideo}
            onStoryEnd={(index: number) => {
              setIndexVideos(index + 1);
            }}
            onAllStoriesEnd={() => {
              setIndexPlaylist(indexPlaylistCurrent());
            }}
            preventDefault={true}
            storyStyles={{}}
          />
        )}
      </div>
    </div>
  );
};

export default ViewVideosSetel;
